import VerifyBadgeIcon from 'assets/Icons/VerifyBadgeIcon';
import { useRouter } from 'next/router';
import React, { useEffect, useRef } from 'react';
import { useRecoilValue } from 'recoil';

import { ShouldRender } from '@/components/shared/basic/ShouldRender';

import { user } from '@/atoms/user';
import { User } from '@/utils/interfaces/User';

interface Props {
  sendVerificationLink: () => Promise<void>;
  setShowDropDown: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
}

const CompleteProfile: React.FC<Props> = ({
  onClose,
  sendVerificationLink,
  setShowDropDown,
}) => {
  const userData = useRecoilValue<User | undefined>(user);
  const router = useRouter();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    const onWheel = (e: WheelEvent) => {
      if (container && e.deltaY !== 0) {
        e.preventDefault();
        container.scrollLeft += e.deltaY;
      }
    };

    container?.addEventListener('wheel', onWheel, { passive: false });

    return () => container?.removeEventListener('wheel', onWheel);
  }, []);

  return (
    <ShouldRender
      check={
        !userData?.email_verified_at ||
        !(
          userData?.user_attributes?.find(
            (attr) => attr.attribute_key === 'onboarding_completed',
          )?.attribute_value === '1'
        ) ||
        !userData?.user_attributes?.find(
          (attr) => attr.attribute_key === 'personality_test',
        )
      }
    >
      <div className='flex flex-col gap-3 w-full px-5'>
        <p className='text-xs/5 text-grayZl-500 font-semibold'>
          Complete your profile:
        </p>
        <div
          ref={containerRef}
          id='scroll-container'
          className='flex items-center gap-2 overflow-auto no-scrollbar whitespace-nowrap'
        >
          <ShouldRender check={!userData?.email_verified_at}>
            <button
              onClick={() => {
                sendVerificationLink();
                setShowDropDown(false);
                onClose();
              }}
              className='flex-shrink-0 text-nowrap flex items-center justify-center pl-2 pr-2.5 py-1.5 rounded-full gap-1 text-xs/5 text-white font-semibold'
              style={{
                background: 'linear-gradient(180deg, #6199FF 0%, #045CFB 100%)',
              }}
            >
              <VerifyBadgeIcon fill='white' width={20} height={20} />
              Get Verified
            </button>
          </ShouldRender>
          <ShouldRender check={!(userData?.onboarding_completed === true)}>
            <button
              onClick={() => {
                router.push('/onboarding');
                onClose();
                setShowDropDown(false);
              }}
              className='flex-shrink-0 relative overflow-hidden text-nowrap flex items-center justify-center px-2.5 py-1.5 rounded-full text-xs/5 text-white font-semibold bg-grayZl-900'
            >
              Complete Onboarding
              <span className='absolute top-0  w-5 h-full bg-white blur-lg animate-slide'></span>
            </button>
          </ShouldRender>
          <ShouldRender
            check={
              !userData?.user_attributes?.find(
                (attr) => attr.attribute_key === 'personality_test',
              )
            }
          >
            <button
              onClick={() => {
                router.push('/personality_test');
                onClose();
                setShowDropDown(false);
              }}
              className=' flex-shrink-0 relative overflow-hidden text-nowrap flex items-center justify-center px-2.5 py-1.5 rounded-full text-xs/5 text-white font-semibold bg-grayZl-900'
            >
              Check Personality Type
              <span className='absolute top-0  w-5 h-full bg-white blur-lg animate-slide'></span>
            </button>
          </ShouldRender>
        </div>
      </div>
    </ShouldRender>
  );
};

export default CompleteProfile;
